import { EMPTY_SELECT_OPTION } from 'Constants/form'

export const updateTrackingModalFormDefaultValues = {
  carrier: EMPTY_SELECT_OPTION,
  trackingReference: '',
}
